export default function BriefingSteps() {
  const whatsappUrl =
    'https://wa.me/5592984398338?text=Ol%C3%A1!%20Vim%20pelo%20site%20do%20Manaus%20Digital%20Podcast%20e%20gostaria%20de%20reservar%20o%20meu%20epis%C3%B3dio.%20Pode%20me%20ajudar%3F';

  const steps = [
    {
      number: '01',
      icon: 'ri-whatsapp-line',
      title: 'Entre em Contato',
      description:
        'Envie uma mensagem pelo WhatsApp para confirmar sua participação e tirar dúvidas iniciais sobre o episódio.',
      highlight: false,
    },
    {
      number: '02',
      icon: 'ri-user-heart-line',
      title: 'Envie sua Foto e Mini Bio',
      description:
        'Encaminhe uma foto profissional (boa resolução) e uma mini bio com até 3 linhas sobre você e seu trabalho. Esses materiais serão usados na divulgação do episódio.',
      highlight: true,
      tag: 'Importante',
    },
    {
      number: '03',
      icon: 'ri-calendar-check-line',
      title: 'Agendamento da Gravação',
      description:
        'Após confirmar sua participação, escolhemos juntos a melhor data e horário para a gravação no Container Studio.',
      highlight: false,
    },
    {
      number: '04',
      icon: 'ri-file-list-3-line',
      title: 'Alinhamento do Roteiro',
      description:
        'Realizamos uma reunião prévia (online ou presencial) para alinhar os temas, pontos-chave e a estrutura do episódio. Você chega preparado e confiante.',
      highlight: false,
    },
    {
      number: '05',
      icon: 'ri-mic-2-line',
      title: 'Dia da Gravação',
      description:
        'Chegue ao Container Studio no horário combinado. Nossa equipe cuida de tudo: iluminação, áudio, câmeras e produção. Você só precisa ser você mesmo!',
      highlight: false,
    },
    {
      number: '06',
      icon: 'ri-scissors-cut-line',
      title: 'Edição e Publicação',
      description:
        'Após a gravação, nossa equipe realiza a edição completa do vídeo e do áudio. O episódio é publicado no YouTube e no Spotify.',
      highlight: false,
    },
    {
      number: '07',
      icon: 'ri-share-line',
      title: 'Você será marcado no instagram',
      description:
        'Marcaremos o seu perfil no post do nosso feed e nos stories para divulgar nas suas redes sociais e amplificar seu alcance.',
      highlight: false,
    },
  ];

  return (
    <section className="py-24" style={{ background: 'linear-gradient(180deg, #f0f5ff 0%, #ffffff 100%)' }}>
      <div className="max-w-5xl mx-auto px-6">
        {/* Badge */}
        <div className="flex justify-center mb-6">
          <div
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full"
            style={{ background: 'rgba(43,111,212,0.1)', color: '#1A3A8F' }}
          >
            <i className="ri-route-line"></i>
            <span className="font-semibold text-sm whitespace-nowrap">Guia do Entrevistado</span>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-900 mb-4 leading-tight">
          Seu passo a passo para
        </h2>
        <h2 className="text-4xl md:text-5xl font-serif italic text-center mb-14 leading-tight" style={{ color: '#2B6FD4' }}>
          um episódio incrível ✨
        </h2>

        {/* Steps */}
        <div className="relative">
          {/* Vertical line */}
          <div
            className="absolute left-8 top-0 bottom-0 w-0.5 hidden md:block"
            style={{ background: 'linear-gradient(180deg, #2B6FD4 0%, #00BFFF 100%)' }}
          ></div>

          <div className="space-y-6">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`relative flex gap-6 rounded-2xl p-6 md:p-8 transition-all hover:-translate-y-0.5 hover:shadow-md ${
                  step.highlight
                    ? 'border-2'
                    : 'border border-transparent'
                }`}
                style={
                  step.highlight
                    ? {
                        background: 'linear-gradient(135deg, rgba(43,111,212,0.08) 0%, rgba(0,191,255,0.08) 100%)',
                        borderColor: '#00BFFF',
                      }
                    : { background: 'rgba(255,255,255,0.9)', boxShadow: '0 1px 8px rgba(26,58,143,0.07)' }
                }
              >
                {/* Step number circle */}
                <div
                  className="w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0 font-extrabold text-lg z-10"
                  style={
                    step.highlight
                      ? { background: 'linear-gradient(135deg, #1A3A8F, #00BFFF)', color: '#fff' }
                      : { background: 'rgba(43,111,212,0.1)', color: '#2B6FD4' }
                  }
                >
                  {step.number}
                </div>

                {/* Content */}
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2 flex-wrap">
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className={`${step.icon} text-xl`} style={{ color: step.highlight ? '#00BFFF' : '#2B6FD4' }}></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900">{step.title}</h3>
                    {step.tag && (
                      <span
                        className="text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap"
                        style={{ background: 'rgba(0,191,255,0.15)', color: '#1A3A8F' }}
                      >
                        {step.tag}
                      </span>
                    )}
                  </div>
                  <p className="text-gray-600 leading-relaxed">{step.description}</p>

                  {/* Extra tip for photo/bio step */}
                  {step.number === '02' && (
                    <div
                      className="mt-4 rounded-xl p-4 flex items-start gap-3"
                      style={{ background: 'rgba(26,58,143,0.06)' }}
                    >
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-lightbulb-line text-base" style={{ color: '#2B6FD4' }}></i>
                      </div>
                      <p className="text-sm text-gray-700">
                        <strong>Dica:</strong> Prefira fotos com fundo neutro ou profissional. A mini bio deve incluir seu nome, área de atuação e um diferencial seu. Exemplo: <em>"João Silva, fundador da StartupX, especialista em inovação aberta na Amazônia."</em>
                      </p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA WhatsApp */}
        <div className="mt-16 text-center">
          <p className="text-gray-500 mb-6 text-lg">Pronto para dar o próximo passo?</p>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 text-white font-bold text-lg px-10 py-5 rounded-2xl transition-all hover:scale-105 hover:shadow-xl cursor-pointer whitespace-nowrap"
            style={{ background: 'linear-gradient(135deg, #1A3A8F 0%, #2B6FD4 60%, #00BFFF 100%)' }}
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Quero reservar o meu episódio!
          </a>
          <p className="text-gray-400 text-sm mt-4">
            Você será redirecionado para o WhatsApp com uma mensagem já preenchida 🚀
          </p>
        </div>
      </div>
    </section>
  );
}
